import { JsonRpcProvider } from 'ethers';
import { WORKLOOB_NET } from './workloobNetwork';

export function getBaseRpcUrls() {
  const custom = process.env.REACT_APP_BASE_RPC_URL;
  const urls = [...WORKLOOB_NET.rpcUrls];
  if (custom && !urls.includes(custom)) {
    urls.unshift(custom);
  }
  if (WORKLOOB_NET.isMainnet && !urls.includes('https://base-rpc.publicnode.com')) {
    urls.push('https://base-rpc.publicnode.com');
  }
  return urls.filter(Boolean);
}

/** @deprecated use getBaseRpcUrls */
export function getBaseMainnetRpcUrls() {
  return getBaseRpcUrls();
}

export function createBaseProvider(rpcUrl) {
  return new JsonRpcProvider(rpcUrl, WORKLOOB_NET.chainId, { staticNetwork: true });
}

/** @deprecated use createBaseProvider */
export function createBaseMainnetProvider(rpcUrl) {
  return createBaseProvider(rpcUrl);
}

export async function withBaseProvider(fn) {
  const urls = getBaseRpcUrls();
  let lastError;
  for (const url of urls) {
    try {
      const provider = createBaseProvider(url);
      return await fn(provider);
    } catch (err) {
      lastError = err;
      const msg = String(err?.message || err?.shortMessage || err?.code || '');
      if (
        msg.includes('rate limit') ||
        msg.includes('missing revert data') ||
        msg.includes('timeout') ||
        msg.includes('CALL_EXCEPTION')
      ) {
        continue;
      }
      throw err;
    }
  }
  throw lastError || new Error(`Could not connect to Base RPC (${WORKLOOB_NET.network})`);
}

/** @deprecated use withBaseProvider */
export async function withBaseMainnetProvider(fn) {
  return withBaseProvider(fn);
}
